import classNames from 'classnames/bind';
import styles from './ActivityDashboard.module.css';
import { ActivityDashboardProps } from '../../../types/dashboard';
import ActivityCard from '../ActivityCard';
import DateRangePicker from '../../DataRangePicker';
import { getDiff } from '../../../utils/date';
import {
  COLLECTED_INFO_MESSAGE,
  COLLECTING_INFORMATION,
} from '../../../constants';

export default function ActivityDashboard({
  cards,
  dateRange,
  actionButton,
  dateRangeDescSuffix,
  onCardClick,
  onDateChange,
  children,
}: ActivityDashboardProps) {
  const cx = classNames.bind(styles);

  const handleCardClick = (cardId: string) => {
    onCardClick?.(cardId);
  };

  const handleDateChange = (startDate: string, endDate: string) => {
    onDateChange?.(startDate, endDate);
  };

  return (
    <div className={cx('learning-activity_content')}>
      {!children && (
        <ul className={cx('learning-activity_grid')}>
          {cards.map((card) => (
            <ActivityCard key={card.id} {...card} onClick={handleCardClick} />
          ))}
        </ul>
      )}

      {children}

      {dateRange && (
        <div className={cx('dash_date')}>
          {actionButton && (
            <div className={cx('btn_wrap')}>
              <button
                className={cx('btn', 'skyt', actionButton.className)}
                onClick={actionButton.onClick}
              >
                <span>{actionButton.text}</span>
              </button>
            </div>
          )}

          <div className={cx('date')}>
            ※
            {getDiff(
              dateRange.today || dateRange.endDate,
              dateRange.regDate || dateRange.startDate
            ) ? (
              <DateRangePicker
                startDate={dateRange.startDate}
                endDate={dateRange.endDate}
                startPicker={{
                  min: dateRange.regDate || dateRange.startDate,
                  max: dateRange.endDate,
                }}
                endPicker={{
                  min: dateRange.startDate,
                  max: dateRange.today || dateRange.endDate,
                }}
                onChange={handleDateChange}
                descSuffix={dateRangeDescSuffix || COLLECTED_INFO_MESSAGE}
              />
            ) : (
              <span>{COLLECTING_INFORMATION}</span>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
